export function getBaseURL() {
  return 'https://kuaigongxuapi.promptboom.org'
  // return 'http://127.0.0.1:8787'
}
